import { required, email } from 'vuelidate/lib/validators';
import abstractValidatorMixin from '../abstractValidator.mixin';

export default {
    mixins: [abstractValidatorMixin],
    data() {
        return {
            serverErrors: {
                email: []
            }
        };
    },
    validations: {
        email: { required, email }
    },
    computed: {
        emailErrors() {
            return this.checkErrors('email');
        }
    }
};
